// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__cKAE6","rootSmall":"AddTileButton_rootSmall__rqtL6"};